import * as angular from "angular";

angular
  .module('bringoz.admin.skills')
  .config(skillsConfig);

/* @ngInject */
function skillsConfig($stateProvider) {

  $stateProvider

    // Labels
    .state('skills', {
      parent: 'bringoz.site',
      url: '/skills',
      template: '<skills-view skills="vm.skills"></skills-view>',
      controllerAs: 'vm',
      controller: function($scope, triBreadcrumbsService, skills, site) {

        this.skills = skills;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Skills"});
        triBreadcrumbsService.addCrumb({name: "Configurations"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      },
      resolve: {
        skills: function(site, skillsRequests) {
          return skillsRequests.getAll();
        }
      }
    });

}
